// extracted by mini-css-extract-plugin
export default {"offerBlock":"LHYnPniZ","slider":"WYMkX5dX","sliderCaption":"vXrVFbgv","controls":"La7_HbXE","sliderValues":"l7_m6umI","deleteButton":"TLX4UtfD","checkboxPrice":"rBzISxWc"};